export const TEST_IDS = {
  setupGuideCard: 'setup-guide-card',
  shipmentOffersSection: 'shipment-offers-section',
  shipmentOffersCard: 'shipment-offers-card',
  shipmentOffersMobileCard: 'shipment-offers-mobile-card',
  shipmentOffersEmpty: 'shipment-offers-empty',
  shipmentOffersEmptyFindLoadsButton: 'shipment-offers-empty-find-loads',
  shipmentOffersEmptyDedicatedLanesButton: 'shipment-offers-empty-dedicated-lanes',
  needsAttentionCard: 'needs-attention-card',
  activeShipmentsSection: 'active-shipments-section',
}

export const HOMEPAGE_BOX_SHADOW = '0px 1px 2px 0px rgba(0, 0, 0, 0.15)'
